import { Autorizacion, RolUsuario } from 'src/app/compartido/autorizacion/autorizacion.models';
import { Icono, Imagenes } from 'src/app/compartido/utilidades/compartido.static';
import { AUTORIZACION_PAGINAS } from '../../compartido/autorizacion/autorizacion.static';

/* Categorías de navegación */
export type CategoriaNavegacion = {
  nombre: string;
  paginas: PaginaNavegacion[];
  autorizacion?: Autorizacion;
};

/* Pagina de la navegación */
export type PaginaNavegacion = {
  nombre: string;
  url: string;
  icono: Icono;
  imagen: string;
  autorizacion: Autorizacion;
};

/* Navegación de la plataforma */
export const NAVEGACION: CategoriaNavegacion[] = [
  {
    nombre: 'Dispensación',
    paginas: [
      {
        nombre: 'Tareas de Eleva',
        url: '/tareas-eleva',
        icono: Icono.TAREAS_DIA,
        imagen: Imagenes.TAREAS_DIA,
        autorizacion: AUTORIZACION_PAGINAS['Tareas de Eleva'],
      },
      {
        nombre: 'Tareas de Organización',
        url: '/tareas-org',
        icono: Icono.TAREAS_DIA,
        imagen: Imagenes.TAREAS_DIA,
        autorizacion: AUTORIZACION_PAGINAS['Tareas de Organización'],
      },
      {
        nombre: 'Tareas de Aliado',
        url: '/tareas-aliado',
        icono: Icono.TAREAS_DIA,
        imagen: Imagenes.TAREAS_DIA,
        autorizacion: AUTORIZACION_PAGINAS['Tareas de Aliado'],
      },
      {
        nombre: 'Cajas de Auxiliares',
        url: '/caja',
        icono: Icono.CAJA,
        imagen: Imagenes.CAJA,
        autorizacion: AUTORIZACION_PAGINAS['Cajas de Auxiliares'],
      },
      {
        nombre: 'Cuentas de Pilotos',
        url: '/caja/cuentas',
        icono: Icono.PAGAR,
        imagen: Imagenes.BILLETES,
        autorizacion: AUTORIZACION_PAGINAS['Cuentas de Pilotos'],
      },
      {
        nombre: 'Órdenes',
        url: '/ordenes',
        icono: Icono.ORDENES,
        imagen: Imagenes.ORDENES,
        autorizacion: AUTORIZACION_PAGINAS['Órdenes'],
      },
      {
        nombre: 'Órdenes Express',
        url: '/ordenes/express',
        icono: Icono.EXPRESS,
        imagen: Imagenes.EXPRESS,
        autorizacion: AUTORIZACION_PAGINAS['Órdenes'],
      },
      {
        nombre: 'Planillas de Recogida',
        url: '/planillas',
        icono: Icono.PLANILLA_RECOGIDA,
        imagen: Imagenes.PLANILLA_RECOGIDA,
        autorizacion: AUTORIZACION_PAGINAS['Planillas de Recogida'],
      },
      {
        nombre: 'Planillas de Retorno',
        url: '/planillas/retorno',
        icono: Icono.RETORNAR,
        imagen: Imagenes.PLANILLA_RETORNO,
        autorizacion: AUTORIZACION_PAGINAS['Planillas de Retorno'],
      },
      {
        nombre: 'Recogidas',
        url: '/ordenes/recogidas',
        icono: Icono.RECOGIDAS,
        imagen: Imagenes.RECOGIDAS,
        autorizacion: AUTORIZACION_PAGINAS['Recogidas'],
      },
      {
        nombre: 'Domicilios',
        url: '/domicilios',
        icono: Icono.DOMICILIOS,
        imagen: Imagenes.DOMICILIOS,
        autorizacion: AUTORIZACION_PAGINAS['Domicilios'],
      },
      {
        nombre: 'Rutas',
        url: '/domicilios/rutas',
        icono: Icono.RUTAS,
        imagen: Imagenes.RUTAS,
        autorizacion: AUTORIZACION_PAGINAS['Rutas'],
      },
      {
        nombre: 'Clientes',
        url: '/clientes',
        icono: Icono.CLIENTES,
        imagen: Imagenes.CLIENTES,
        autorizacion: AUTORIZACION_PAGINAS['Clientes'],
      },
    ],
  },
  {
    nombre: 'Pilotos Dedicados',
    paginas: [
      {
        nombre: 'Bitácora de Encargos',
        url: '/servicios/encargos',
        icono: Icono.ENCARGO,
        imagen: Imagenes.ENCARGOS,
        autorizacion: AUTORIZACION_PAGINAS['Bitácora de Encargos'],
      },
    ],
  },
  {
    nombre: 'Servicios Adicionales',
    paginas: [
      {
        nombre: 'Paquetería Nacional',
        url: '/paquetes',
        icono: Icono.PAQUETES,
        imagen: Imagenes.PAQUETES,
        autorizacion: AUTORIZACION_PAGINAS['Paquetes'],
      },
      {
        nombre: 'Traslados Locales',
        url: '/paquetes/traslados',
        icono: Icono.TRASLADOS,
        imagen: Imagenes.TRASLADOS,
        autorizacion: AUTORIZACION_PAGINAS['Traslados Locales'],
      },
      {
        nombre: 'Digiturnos',
        url: '/servicios/digiturnos',
        icono: Icono.DIGITURNO,
        imagen: Imagenes.DIGITURNO,
        autorizacion: AUTORIZACION_PAGINAS['Digiturnos'],
      },
      {
        nombre: 'Control de Trayectos',
        url: '/trayectos',
        icono: Icono.TRAYECTOS,
        imagen: Imagenes.TRAYECTOS,
        autorizacion: AUTORIZACION_PAGINAS['Trayectos'],
      },
    ],
  },
  {
    nombre: 'Rastreo',
    paginas: [
      {
        nombre: 'Mapa de Pilotos',
        url: '/rastreo/mapa-pilotos',
        icono: Icono.MAPA,
        imagen: Imagenes.MAPA,
        autorizacion: AUTORIZACION_PAGINAS['Mapa de Pilotos'],
      },
      {
        nombre: 'Jornadas',
        url: '/rastreo/jornadas',
        icono: Icono.JORNADAS,
        imagen: Imagenes.JORNADAS,
        autorizacion: AUTORIZACION_PAGINAS['Jornadas'],
      },
    ],
  },
  {
    nombre: 'CRM',
    paginas: [
      {
        nombre: 'Tiquetes',
        url: '/crm',
        icono: Icono.TIQUETES,
        imagen: Imagenes.TIQUETES,
        autorizacion: AUTORIZACION_PAGINAS['Tiquetes'],
      },
      {
        nombre: 'Chats',
        url: '/crm/chats',
        icono: Icono.CHATS,
        imagen: Imagenes.CHATS,
        autorizacion: AUTORIZACION_PAGINAS['Chats'],
      },
      {
        nombre: 'Campañas WhatsApp',
        url: '/campanas',
        icono: Icono.CAMPANAS,
        imagen: Imagenes.CAMPANAS,
        autorizacion: AUTORIZACION_PAGINAS['Campañas'],
      },
    ],
  },
  {
    nombre: 'Administración',
    paginas: [
      {
        nombre: 'Planillas de Rodamiento',
        url: '/planillas/rodamiento',
        icono: Icono.PLANILLA_RODAMIENTO,
        imagen: Imagenes.PLANILLA_RODAMIENTO,
        autorizacion: AUTORIZACION_PAGINAS['Planillas de Rodamiento'],
      },
      {
        nombre: 'Verificaciones de Identidad',
        url: '/clientes/verificaciones',
        icono: Icono.VERIFICACIONES,
        imagen: Imagenes.VERIFICACIONES,
        autorizacion: AUTORIZACION_PAGINAS['Verificaciones de Identidad'],
      },
      {
        nombre: 'Mi Perfil',
        url: '/clientes/perfil',
        icono: Icono.PERFIL,
        imagen: Imagenes.PERFIL,
        autorizacion: {
          ...AUTORIZACION_PAGINAS['Ver Cliente'],
          roles: [RolUsuario.CLIENTE],
        },
      },
      {
        nombre: 'Cuentas de Cobro',
        url: '/facturacion',
        icono: Icono.CUENTA_COBRO,
        imagen: Imagenes.CUENTAS_COBRO,
        autorizacion: AUTORIZACION_PAGINAS['Cuentas de Cobro'],
      },
      {
        nombre: 'Reportes',
        url: '/reportes',
        icono: Icono.REPORTES,
        imagen: Imagenes.REPORTES,
        autorizacion: AUTORIZACION_PAGINAS['Reportes'],
      },
    ],
  },
];
